import { useQuery } from '@tanstack/react-query'
import { Constants } from 'constants/constants'
import { QueryKeys } from 'constants/query-keys'
import { fetchAssetsProtectionSecureData } from 'queries/assets-protection/secure/secure'
import { ShortageFetchProps } from 'types/api'
import { IResponse } from 'utils/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'
import {
    getGreenfieldDrillValues,
    getGreenfieldLocationFilter,
} from 'utils/greenfield'

const getSecureFilters = (location: string) => ({
    ...getGreenfieldLocationFilter(location),
    ...getGreenfieldDrillValues(location),
})

export function useAssetsProtectionSecureStore({
    env,
    accessToken,
    location,
    filters,
}: ShortageFetchProps): IResponse {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME
    const greenfieldCardNumber =
        Constants.GREENFIELD_CARDS.ASSETS_PROTECTION.SECURE
    const secureFilters = getSecureFilters(location)

    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.ASSETS_PROTECTION_SECURE, location],
        () =>
            fetchAssetsProtectionSecureData({
                env,
                accessToken,
                dynamicSubPath: greenfieldCardNumber,
                filters: secureFilters,
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
